import { useMutation } from '@tanstack/react-query'
import { practiceApi } from '../api/practice.api'
import type { Answer, StartRunPayload } from '../types'

/**
 * Orchestre le cycle de vie d'une partie (SPEC §12) : démarrage, soumission
 * groupée des réponses, clôture. Les trois étapes restent des mutations
 * indépendantes — c'est `GameShell` qui les enchaîne dans le bon ordre, ce
 * hook ne connaît aucune règle métier, seulement le contrat HTTP.
 */
export function usePracticeRun() {
  const startMutation = useMutation({
    mutationFn: (payload: StartRunPayload) => practiceApi.startRun(payload).then((r) => r.data.data),
  })

  const submitAnswersMutation = useMutation({
    mutationFn: ({ runId, answers }: { runId: string; answers: Answer[] }) =>
      practiceApi.submitAnswers(runId, answers).then((r) => r.data.data),
  })

  const finishMutation = useMutation({
    mutationFn: (runId: string) => practiceApi.finishRun(runId).then((r) => r.data.data),
  })

  return {
    run: startMutation.data ?? null,
    startRun: startMutation.mutateAsync,
    isStarting: startMutation.isPending,
    startError: startMutation.error,

    submitAnswers: (runId: string, answers: Answer[]) =>
      submitAnswersMutation.mutateAsync({ runId, answers }),
    isSubmitting: submitAnswersMutation.isPending,

    finishRun: finishMutation.mutateAsync,
    isFinishing: finishMutation.isPending,
    result: finishMutation.data ?? null,
  }
}
